import Vue from 'vue'
import axios from "axios";
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)
import handleRouter from "./routerHandler"
//  '简化路由的写法  不需要 定义 变量再引入'
const router = new Router({
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [{
		path: '/',
		name: 'home',
		meta: {
			title: '云仓首页',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/home')
	},
	{
		path: '/warehouse/hotel',
		name: 'hotel',
		meta: {
			title: '云仓酒店',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/hotel')
	},
	{
		path: '/warehouse/hotel/details',
		name: 'hotel_details',
		meta: {
			title: '云仓酒店详情',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/hotel/details')
	},
	{
		path: '/warehouse/ticket',
		name: 'ticket',
		meta: {
			title: '云仓门票',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/ticket')
	},
	{
		path: '/warehouse/ticket/details',
		name: 'ticket_details',
		meta: {
			title: '云仓门票详情',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/ticket/details')
	},
	{
		path: '/warehouse/scene',
		name: 'scene',
		meta: {
			title: '云仓景酒',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/scene')
	},
	{
		path: '/warehouse/scene/details',
		name: 'scene_details',
		meta: {
			title: '云仓景酒详情',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/scene/details')
	},
	{
		path: '/warehouse/commodity',
		name: 'commodity',
		meta: {
			title: '云仓百货',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/commodity')
	},
	{
		path: '/warehouse/commodity/details',
		name: 'commodity_details',
		meta: {
			title: '云仓百货详情',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/commodity/details')
	},
	{
		path: '/warehouse/sale',
		name: 'sale',
		meta: {
			title: '云仓抢购',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/sale')
	},
	{
		path: '/warehouse/sale/details',
		name: 'sale_details',
		meta: {
			title: '云仓抢购详情',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/sale/details')
	},
	{
		path: '/warehouse/tour',
		name: 'tour',
		meta: {
			title: '云仓国内跟团',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/tour')
	},
	{
		path: '/warehouse/emigrate',
		name: 'emigrate',
		meta: {
			title: '云仓出境跟团',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/tour/emigrate')
	},

	{
		path: '/warehouse/tour/details',
		name: 'tour_details',
		meta: {
			title: '云仓国内跟团详情',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/tour/details')
	},
	{
		path: '/warehouse/visa',
		name: 'visa',
		meta: {
			title: '云仓签证',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/visa')
	},
	{
		path: '/warehouse/visa/details',
		name: 'visa_details',
		meta: {
			title: '云仓签证详情',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/visa/details')
	},
	{
		path: '/warehouse/center',
		name: 'center',
		meta: {
			title: '云仓我的主页-我的订单-我卖出的',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/center')
	},
	{
		path: '/warehouse/center/details',
		name: 'orderdetails',
		meta: {
			title: '云仓我的主页-我的订单-订单详情',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/center/details')
	},

	{
		path: '/warehouse/center/purchase',
		name: 'purchase',
		meta: {
			title: '云仓我的主页-我的订单-我采购的',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/center/purchase')
	},
	{
		path: '/warehouse/center/distribution',
		name: 'distribution',
		meta: {
			title: '云仓我的主页-我的产品-我分销的',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/center/distribution')
	},
	{
		path: '/warehouse/center/supply',
		name: 'supply',
		meta: {
			title: '云仓我的主页-我的产品-我供应的',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/center/supply')
	},
	{
		path: '/warehouse/center/supplySetting',
		name: 'supplySetting',
		meta: {
			title: '云仓我的主页-我的产品-我供应的-结算价设置',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/center/supplySetting')
	},
	{
		path: '/warehouse/center/recharge',
		name: 'recharge',
		meta: {
			title: '云仓我的主页-财务中心-充值/交易',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/center/recharge')
	},
	{
		path: '/warehouse/center/partner',
		name: 'partner',
		meta: {
			title: '云仓我的主页-伙伴管理-我的伙伴',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/center/partner')
	},
	{
		path: '/warehouse/searchall',
		name: 'searchall',
		meta: {
			title: '搜索',
			keepAlive: true, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/warehouse/searchall')
	},
	{
		path: '/error/loginError',
		name: 'loginError',
		meta: {
			title: '登录过期',
			keepAlive: false, // '不需要缓存'
			isBack: false, //'用于判断上一个页面是哪个'
			auth: true, //判断是否需要登录
		},
		component: () =>
			import('@/page/error/loginError')
	},
	]
})

//http response 拦截器
axios.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		// console.log(error.response);
		if (error.response.status == 999) {
      localStorage.removeItem("cloudUser")
			router.push({
				path: "/error/loginError",
				querry: {
					redirect: router.currentRoute.fullPath
				} //从哪个页面跳转
			})
		}
		return Promise.reject(error)
	}
)
handleRouter(router);
// //  '根据 路由来定义  title 动态切换'
// router.beforeEach((to, from, next) => {
// 	/* 路由发生变化修改页面title */
// 	if (to.meta.title) {
// 		document.title = to.meta.title
// 	}
// 	next()
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js